<template>
  <div>
    <nav v-show="isNavBarVisible" id="navbar-main" class="navbar is-fixed-top">
      <div class="navbar-brand">
        <a class="navbar-item" @click.prevent="menuToggleMobile">
          <b-icon :icon="menuToggleMobileIcon"/>
        </a>
        <div class="navbar-item">
          <div class="control">
            <search-bar/>
          </div>
        </div>
      </div>
      <div class="navbar-brand is-right">
        <a class="navbar-item navbar-item-menu-toggle is-hidden-desktop" @click.prevent="menuNavBarToggle">
          <b-icon :icon="menuNavBarToggleIcon"/>
        </a>
      </div>
      <div class="navbar-menu fadeIn animated faster" :class="{'is-active':isMenuNavBarActive}">
        <div class="navbar-end">
          <!-- <nav-bar-menu class="has-divider">
            <b-icon icon="menu" custom-size="default"/>
            <span>Sample Menu</span>
            <div slot="dropdown" class="navbar-dropdown">
              <router-link to="/profile" class="navbar-item" exact-active-class="is-active">
                <b-icon icon="account" custom-size="default"/>
                <span>My Profile</span>
              </router-link>
              <a class="navbar-item">
                <b-icon icon="settings" custom-size="default"/>
                <span>Settings</span>
              </a>
              <a class="navbar-item">
                <b-icon icon="email" custom-size="default"/>
                <span>Messages</span>
              </a>
              <hr class="navbar-divider">
              <a class="navbar-item">
                <b-icon icon="logout" custom-size="default"/>
                <span>Log Out</span>
              </a>
            </div>
          </nav-bar-menu> -->
          <!-- <a href="https://justboil.me/bulma-admin-template/one" class="navbar-item has-divider is-desktop-icon-only" title="About">
            <b-icon icon="bell" custom-size="default"/>
            <span>Notificaciones</span>
          </a> -->

          <!-- <nav-bar-menu class="has-divider has-user-avatar">
            <user-avatar/>
            <div class="is-user-name">
              <span>{{ userName }}</span>
            </div>

            <div slot="dropdown" class="navbar-dropdown">
              <a class="navbar-item">
                <b-icon icon="account" custom-size="default"></b-icon>
                <span>Perfil</span>
              </a>
              <a class="navbar-item">
                <b-icon icon="settings" custom-size="default"></b-icon>
                <span>Settings</span>
              </a>
              <a class="navbar-item">
                <b-icon icon="email" custom-size="default"></b-icon>
                <span>Messages</span>
              </a>
              <hr class="navbar-divider">
              <a class="navbar-item">
                <b-icon icon="logout" custom-size="default"></b-icon>
                <span>Log Out</span>
              </a>
            </div>
          </nav-bar-menu> -->
          <a class="navbar-item">
            <user-avatar/>
            <div class="is-user-name">
              <b-tooltip :label="userRoles" position="is-bottom">
                <span>&nbsp;&nbsp;{{ userName }}</span>
              </b-tooltip>
            </div>
          </a>
          <a class="navbar-item is-desktop-icon-only" title="Log out" @click="logout">
            <b-icon icon="logout" custom-size="default"/>
            <span>Cerrar Sesión</span>
          </a>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
import { mapState } from 'vuex'
// import NavBarMenu from '@/components/NavBarMenu'
import UserAvatar from '@/components/UserAvatar'
import CredentialsService from '@/services/CredentialsService.js'
import SearchBar from '@/components/SearchBar'

export default {
  name: 'NavBar',
  components: {
    UserAvatar,
    SearchBar
    // NavBarMenu
  },
  data () {
    return {
      isMenuNavBarActive: false
    }
  },
  computed: {
    menuNavBarToggleIcon () {
      return (this.isMenuNavBarActive) ? 'close' : 'dots-vertical'
    },
    menuToggleMobileIcon () {
      return this.isAsideMobileExpanded ? 'backburger' : 'forwardburger'
    },
    userRoles () {
      let user = CredentialsService.getUser()
      let rolesDesc = []
      user.roles.map((role) => rolesDesc.push(role.description))
      return rolesDesc.join(' - ')
    },
    ...mapState([
      'isNavBarVisible',
      'isAsideMobileExpanded',
      'userName'
    ])
  },
  methods: {
    menuToggleMobile () {
      this.$store.commit('asideMobileStateToggle')
    },
    menuNavBarToggle () {
      this.isMenuNavBarActive = (!this.isMenuNavBarActive)
    },
    logout () {
      CredentialsService.clearCredentials()
      this.router.push({ name: 'login' })
    }
  }
}
</script>
